import React from 'react';
import {
  Box,
  Heading,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Text,
} from '@chakra-ui/react';
import GoalsManagement from './GoalsManagement';
import ServicesManagement from './ServicesManagement';

function Settings() {
  return (
    <Box>
      <Box mb={6}>
        <Heading
          as="h1"
          size="xl"
          mb={2}
          bgGradient="linear(to-r, brand.darkPurple, brand.darkGray)"
          bgClip="text"
        >
          Settings
        </Heading>
        <Text color="gray.600" fontSize="lg">
          Manage your clinic's configuration and administrative settings
        </Text>
      </Box>

      <Tabs colorScheme="purple" variant="enclosed" isLazy>
        <TabList>
          <Tab>Services</Tab>
          <Tab>Client Goals</Tab>
        </TabList>

        <TabPanels>
          {/* Services Tab */}
          <TabPanel>
            <ServicesManagement />
          </TabPanel>

          {/* Goals Tab */}
          <TabPanel>
            <GoalsManagement />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}

export default Settings;
